import escapeFilterRegex from './escapeFilterRegex'

// based on https://sites.psu.edu/symbolcodes/ipavowels/
export const characterReplaceMap = {
  a: '[aàȁáâäãąāăǎȧạ]',
  e: '[eèȅéêëẽęēĕěėẹ]',
  i: '[iìȉíîïĩįīĭǐị]',
  o: '[oòȍóőôöõǫōŏǒȯọ]',
  u: '[uùȕúűûüũųūŭǔụṵṳ]',
  y: '[yỳýŷÿỹȳẏỵ]',
  w: '[wẁẃŵẅẇẉ]',
  c: '[cćĉç]',
  n: '[nñńǹ]'
}

const replaceableCharactersRegex = new RegExp(
  `[${Object.keys(characterReplaceMap).join('')}]`,
  'g'
)

export default function normalizeFilterRegex(
  sourceRegex: string,
  escapeFn = escapeFilterRegex
) {
  const escapedRegex = escapeFn(sourceRegex)

  if (/[[\]]/.test(escapedRegex)) {
    return escapedRegex
  }

  return escapedRegex
    .toLowerCase()
    .trim()
    .replace(
      replaceableCharactersRegex,
      (matchedCharacter) =>
        characterReplaceMap[
          matchedCharacter as keyof typeof characterReplaceMap
        ]
    )
}
